import { Injectable } from '@angular/core';
import { ContentEventApi } from '@kapi';
import { ContentEventType } from '@ktypes/enums';
import { ContentEvent, JsonObject } from '@ktypes/models';
import { DateTimeUtil } from '@kutil';

@Injectable({
  providedIn: 'root',
})
export class ContentEventBloc {
  constructor(private _contentEventApi: ContentEventApi) {}

  createContentEvent(contentId: string, eventType: ContentEventType, eventInfo?: JsonObject) {
    void this._contentEventApi.createContentEvent(
      new ContentEvent().deserialize({
        contentId,
        deviceCreatedTimestamp: DateTimeUtil.formatInLocal(),
        eventInfo,
        eventType,
      })
    );
  }
}
